export function hasTextAfterOffset(text, offset) {
    return text.slice(offset).trim() !== '';
}
//# sourceMappingURL=hasTextAfterOffset.js.map